var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videoList"},[_c('ul',_vm._l((_vm.courseList),function(item,index){return _c('li',{key:index},[(item.state === '上架')?_c('div',[_c('video-info',{attrs:{"price":item.cost,"title":item.name,"id":item.id,"uptime":item.uptime,"type":item.type,"goto":_vm.goto,"src":item.introduceimg,"shopCount":item.ordernum}})],1):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }